import React, { useEffect } from 'react';
import { Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import { Lightbulb, Rocket, Users } from '../../icons';

const MILESTONES = [
    { Icon: Lightbulb, color: '#fff8e1', iconColor: '#f57f17', title: 'Le déclic',        text: "Une clé oubliée à Nice, un ami à l'aéroport, et un voyageur inconnu qui fait Nice-Paris. En deux heures, le problème est résolu. L'idée germe." },
    { Icon: Rocket,    color: '#e8f5e9', iconColor: '#2e7d32', title: 'La création',      text: "8 mois de travail intense. Brahim KIDOUN quitte son emploi et code jour et nuit pour créer la plateforme qu'il aurait voulu avoir. eudeliv est né." },
    { Icon: Users,     color: '#e3f2fd', iconColor: '#1565c0', title: 'La communauté',    text: "Aujourd'hui, plus de 10 000 membres font confiance à eudeliv pour leurs envois. Une famille, une communauté soudée par la solidarité et le partage." },
];

function History() {
    useEffect(() => { window.scrollTo(0, 0); }, []);

    return (
        <div>
            <div className="page-hero">
                <div className="container">
                    <p className="page-hero__eyebrow">À propos</p>
                    <h1 className="page-hero__title">L'histoire d'eudeliv</h1>
                    <p className="page-hero__subtitle">
                        Comment une clé oubliée à Nice a donné naissance à la plus grande plateforme de transport de colis entre particuliers.
                    </p>
                </div>
            </div>

            {/* Milestones */}
            <section className="section-padding bg-light-gray">
                <div className="container">
                    <div className="row">
                        {MILESTONES.map(({ Icon, color, iconColor, title, text }, i) => (
                            <div key={i} className="col-12 col-md-4 mb-4">
                                <div className="why-card">
                                    <div className="why-card__icon" style={{ background: color }}>
                                        <Icon size={24} strokeWidth={1.8} color={iconColor} />
                                    </div>
                                    <h4 className="why-card__title">{title}</h4>
                                    <p className="why-card__text">{text}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Long story */}
            <div className="container content-page">
                <div className="row justify-content-center">
                    <div className="col-12 col-md-8 col-lg-7">

                        <h3>Comment tout a commencé</h3>
                        <p className="content-page__lead">
                            Brahim KIDOUN a besoin d'un document administratif urgent en France, alors que celui-ci se trouve à Oujda, au Maroc. Les services classiques auraient pris plusieurs semaines. Par chance, un membre de sa famille prend un vol direct, et le document arrive le jour même.
                        </p>

                        <h3>L'idée qui change tout</h3>
                        <p>
                            Brahim commence à comptabiliser les vols quotidiens Maroc-France : des centaines de trajets, des milliers de voyageurs potentiels. Et si chaque bagage vide devenait une opportunité d'envoi ?
                        </p>
                        <p>
                            Après des recherches, il découvre quelques forums désorganisés. Il voit une opportunité évidente : créer une vraie plateforme, structurée, fiable, accessible à tous.
                        </p>

                        <h3>La création d'eudeliv</h3>
                        <p>
                            Fort de ses expériences dans de grandes entreprises et start-ups à travers Montpellier, Nice, Paris et Lyon, Brahim prend la décision de quitter son emploi. Huit mois de travail intense aboutissent à la création de <strong>eudeliv</strong> — acronyme de <em>Easy Universal Delivery</em>.
                        </p>

                        <div style={{ marginTop: 36, padding: '24px 28px', background: 'var(--primary-light)', borderRadius: 16, borderLeft: '4px solid var(--primary)' }}>
                            <p style={{ margin: 0, color: 'var(--dark)', fontStyle: 'italic', fontSize: '1.05rem', lineHeight: 1.7 }}>
                                "Je voulais créer une solution que j'aurais aimé avoir moi-même. Simple, économique, et basée sur la confiance entre les gens."
                            </p>
                            <p style={{ margin: '12px 0 0', fontSize: '0.88rem', fontWeight: 700, color: 'var(--primary-dark)' }}>
                                — Brahim KIDOUN, fondateur d'eudeliv
                            </p>
                        </div>

                        <div className="text-center mt-5">
                            <Link to="/register">
                                <Button color="primary" size="lg" style={{ borderRadius: 50, padding: '14px 32px', fontWeight: 700 }}>
                                    Rejoindre l'aventure
                                </Button>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default History;
